import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  AlterarSenhaDto,
  PreferenciasNotificacao,
  UploadCertificadoDto,
} from '@/types/usuario/usuarioTypes';

import { usuarioService } from './services';

export const alterarSenha = createAsyncThunk(
  'usuario/alterarSenha',
  async (data: AlterarSenhaDto, { rejectWithValue }) => {
    try {
      return await usuarioService.alterarSenha(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const uploadCertificado = createAsyncThunk(
  'usuario/uploadCertificado',
  async (data: UploadCertificadoDto, { rejectWithValue }) => {
    try {
      return await usuarioService.uploadCertificado(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const obterCertificadoAtivo = createAsyncThunk(
  'usuario/obterCertificadoAtivo',
  async (_, { rejectWithValue }) => {
    try {
      return await usuarioService.obterCertificadoAtivo();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const listarCertificados = createAsyncThunk(
  'usuario/listarCertificados',
  async (_, { rejectWithValue }) => {
    try {
      return await usuarioService.listarCertificados();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const removerCertificado = createAsyncThunk(
  'usuario/removerCertificado',
  async (certificadoId: string, { rejectWithValue }) => {
    try {
      await usuarioService.removerCertificado(certificadoId);
      return { certificadoId };
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const salvarPreferenciasNotificacao = createAsyncThunk(
  'usuario/salvarPreferenciasNotificacao',
  async (prefs: PreferenciasNotificacao, { rejectWithValue }) => {
    try {
      return await usuarioService.salvarPreferencias(prefs);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
